// extracted by mini-css-extract-plugin
module.exports = {"network":"wallet-network-selector_network__PQ_yf"};